import styled from 'styled-components';

export const StyledAccordionBody = styled.div`
  overflow: hidden;
  padding: ${(p) =>
    p.isOpen &&
    (p.isPadded
      ? `${p.theme.space[2]} ${p.theme.space[6]}`
      : `${p.theme.space[2]} ${p.theme.space[3]}`)};

  ${(p) =>
    !p.isOpen &&
    `
    height: 0;
    visibility: hidden;
  `}
`;
